import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import MaterialityAnalysis from './pages/MaterialityAnalysis';
import ESRSReporting from './pages/ESRSReporting';
import DMA from './pages/DMA';
import Login from './pages/Login';
import Register from './pages/Register';
import { AuthProvider, useAuth } from './components/AuthProvider';
import './App.css';

function RequireAuth({ children }) {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" />;
  }
  
  return children;
}

function App() {
  const isDevelopment = process.env.NODE_ENV === 'development';

  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Navbar />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={<Home />} />
            <Route path="/materiality-analysis" element={<MaterialityAnalysis />} />
            <Route
              path="/esrs-reporting"
              element={
                <RequireAuth>
                  <ESRSReporting />
                </RequireAuth>
              }
            />
            <Route
              path="/dma"
              element={
                <RequireAuth>
                  <DMA />
                </RequireAuth>
              }
            />
          </Routes>
          {!isDevelopment && (
            <>
              <SpeedInsights />
              <Analytics debug={false} />
            </>
          )}
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
